<mat-expansion-panel (expandedChange)="onExpandedChange($event)" class='expansion-panel'>
    <mat-expansion-panel-header class='expansion-header'>
        <mat-panel-title
                class='expansion-title'>{{ (heading | mxTranslate)() }}
        </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-content></ng-content>
</mat-expansion-panel>